import {
  linkifyText,
  linkifyAndHighlightText,
  parseMentionEmails,
  renderTextWithMentions,
} from "@/lib/textRendering";

window.linkifyText = linkifyText;
window.linkifyAndHighlightText = linkifyAndHighlightText;
window.parseMentionEmails = parseMentionEmails;
window.renderTextWithMentions = renderTextWithMentions;
